// src/pages/TelegramLoginPage.jsx

import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const TelegramLoginPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let handled = false;

    const handleSuccessfulLogin = (token, userId, redirectPath) => {
      if (handled) return;
      handled = true;

      try {
        const decoded = jwtDecode(token);
        if (decoded.exp < Date.now() / 1000) {
          throw new Error('Token expired');
        }

        localStorage.setItem('token', token);
        localStorage.setItem('userId', userId);
        
        // Redirect to the specified path or dashboard
        navigate(redirectPath || '/dashboard');
      } catch (err) {
        console.error('Invalid or expired login token:', err);
        alert('Invalid or expired login token. Please try logging in again.');
        navigate('/login');
      }
    };

    // Get redirect path from query parameters
    const redirectPath = searchParams.get('redirect') || '/dashboard';
    const queryToken = searchParams.get('token');
    const queryUserId = searchParams.get('userId');

    // Scenario 1: Launched via Bot's inline_keyboard with pre-generated token
    if (queryToken && queryUserId) {
      console.log('Attempting login via query parameters (inline_keyboard).');
      handleSuccessfulLogin(queryToken, queryUserId, redirectPath);
      return;
    }

    // Scenario 2: Launched via Bot's Main Menu Button (Telegram Web App initData)
    if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData) {
      console.log('Attempting login via Telegram Web App initData (Menu Button).');
      const initData = window.Telegram.WebApp.initData;

      fetch('https://adey.lucky.et/api/auth/webapp-login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ initData }),
      })
        .then(response => {
          if (!response.ok) {
            return response.json().then(errorData => {
              throw new Error(errorData.message || 'Web App login failed due to server error.');
            });
          }
          return response.json();
        })
        .then(data => {
          if (data.token && data.userId) {
            handleSuccessfulLogin(data.token, data.userId, redirectPath);
          } else {
            throw new Error('Backend did not return token or userId.');
          }
        })
        .catch(err => {
          console.error('Telegram Web App login error:', err);
          alert(`Error logging in via Telegram Web App: ${err.message}. Please try again.`);
          navigate('/login');
        });
      return;
    }

    // If neither scenario applies
    console.log('No valid Telegram login data found. Redirecting to login.');
    alert('No valid Telegram login data found. Please log in through the Telegram bot.');
    navigate('/login');

  }, [navigate, searchParams]);

  return (
    <div className="flex justify-center items-center h-screen text-white bg-gray-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500 mx-auto mb-4"></div>
        <p className="text-xl font-bold">Processing Telegram Login...</p>
      </div>
    </div>
  );
};

export default TelegramLoginPage;